// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1KLEh","alertIcon":"ConfirmModal_alertIcon__1uce5"};